export const SITE_NAME = '073漫画网';
export const SITE_URL = 'https://dropcartoon.github.io';
export const SITE_DESCRIPTION =
  '073漫画网提供《健身教练》漫画免费下拉式阅读，滑动屏幕即可感受力量与汗水的故事。还有热血青春、都市职场、恋爱日常、搞笑日常等精彩漫画每日更新，看漫画免费阅读就到073漫画网。';
export const SITE_KEYWORDS =
  '健身教练漫画,漫画免费阅读,下拉式漫画,073漫画网,热血漫画,都市漫画';

export const CONTACT_INFO = {
  email: 'service@073manhua.com',
  phone: '400-073-0000',
  wechat: 'manhua073',
  address: '湖南省长沙市岳麓区麓谷信息港A座12层',
  hours: '周一至周日 09:00-21:00',
};